import { render, staticRenderFns } from "./FormPersonalInterviniente.vue?vue&type=template&id=546d74ff&scoped=true"
import script from "./FormPersonalInterviniente.vue?vue&type=script&lang=js"
export * from "./FormPersonalInterviniente.vue?vue&type=script&lang=js"
import style0 from "./FormPersonalInterviniente.vue?vue&type=style&index=0&id=546d74ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d74ff",
  null
  
)

export default component.exports